<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" fixed app v-if="status_login === 'T'">
      <div v-if="progress">
        <v-progress-linear :indeterminate="progress" color="primary"></v-progress-linear>
      </div>
      <div v-else>
      <v-layout align-center justify-center class="btn_avatar" column v-if="listbot.length !== 0" @click="getPlayerId(actionF)">
        <v-avatar size="75" style="margin-top: 1em;">
          <v-img :src="profilepicture" v-if="profilepicture"></v-img>
          <v-img :src="require('../../assets/robot1.png')" v-else></v-img>
        </v-avatar>
        <h4 v-if="name.length < 20" style="margin-top: 3px;">{{name}}</h4>
        <h4 v-if="name.length > 20" style="margin-top: 3px;" class="long_text0">{{name}}</h4>
        <span style="margin-top: 4px; margin-bottom:0.5em; font-size: 12px; color: #686868;">ID : {{botid}}</span>
      </v-layout>
      <v-divider v-if="listbot.length !== 0"></v-divider>
      <v-layout>
        <v-list dense>
          <v-list-tile @click="createdaccount('/createaccount-mobile')">
            <v-list-tile-action>
              <v-icon style="font-size: 25px;">add_box</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 16px;">สร้างบัญชี</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-layout>
      <v-divider></v-divider>
      <v-layout style="height: 48px; margin-top: 0.6em; margin-bottom: 10px;" v-if="listbot.length !== 0">
        <v-list>
          <v-list-tile style="margin-top: 0.5em;">
            <v-text-field append-icon="search" label="ค้นหาบอท..." solo clearable v-model="search" style="color: white !important;"></v-text-field>
          </v-list-tile>
        </v-list>
      </v-layout>
      <v-layout v-if="listbot.length !== 0" class="scrolling-wrapper" style="height: calc(94.8vh - 260px);" column>
          <template v-for="(item, index) in Filterlistbot">
            <div avatar :key="index" v-on:click="routeinfobot(item)" style="padding-top: 0px;">
              <v-list-tile  avatar  class="selectF" v-if="actionF == item.tokenuser">
                <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                  <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" >
                  <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
                </v-list-tile-avatar>
                <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                  <v-list-tile-title class="long_text">
                    {{item.nickname}}
                  </v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.status" style="font-size: 12px;" class="long_text"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile avatar v-else class="nonselectF">
                <v-list-tile-avatar  style="padding-left: 1vw; margin-right: 1vw;">
                  <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle">
                  <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title class="long_text">
                    {{item.nickname}}
                  </v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.status" style="font-size: 12px;" class="long_text"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </div>
          </template>
      </v-layout>
      <v-layout v-else align-center justify-center style="padding-top: 20px;">
        <h4>ไม่มีรายการบัญชี</h4>
      </v-layout>
      <!-- <v-divider v-if="listbot.length !== 0"></v-divider> -->
      <!-- <v-layout>
        <v-list style="bottom: 0; position: fixed; margin-bottom: 0.3em;" dense>
          <v-list-tile @click="logout()">
            <v-list-tile-action>
              <v-icon style="font-size: 25px;">fas fa-sign-out-alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 16px;">ออกจากระบบ</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-layout> -->
    </div>
    </v-navigation-drawer>
    <v-toolbar color="white" fixed app v-if="$router.currentRoute.path.split('/')[1] === 'listchat'">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>{{ name }}</v-toolbar-title>
    </v-toolbar>
    <v-content style="background-color: white;">
      <v-layout justify-center align-center v-if="status_login === 'T'" style="background-color: white;">
        <v-flex text-xs-center>
          <router-view @updatelistbot="updatelistbot" @updateprofilebot="updateprofilebot"></router-view>
        </v-flex>
      </v-layout>
    </v-content>
  </v-app>
</template>
<script>
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'
var Centrifuge = require('centrifuge')
var centrifuge = new Centrifuge(process.env.VUE_APP_CENTRIFUGE)
var _ = require('lodash')
export default {
  components: {
  },
  data: () => ({
    search: '',
    list_searchbot: [],
    progress: false,
    drawer: null,
    items: [],
    tokenuser: '',
    listbot: [],
    footer: true,
    profilepicture: '',
    name: '',
    botid: '',
    actionF: '',
    status_login: '',
    groupnameTest: ''
  }),
  props: {
    source: String
  },
  computed: {
    ...sync('*'),
    Filterlistbot () {
      if (this.search !== '' && this.search !== null) {
        return this.listbot.filter(post => {
          return post.nickname.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listbot
      }
    }
  },
  // mounted () {
  //   if (this.status_login === 'T') {
  //     console.log('obj')
  //     this.check_admin_bot()
  //   } else {
  //     this.$router.push('/login')
  //   }
  // },
  created () {
    // console.log(this.$route.params.id)
    this.status_login = localStorage.getItem('status_login')
    // this.check_admin_bot()
    if (this.status_login === 'T') {
      this.$socket.emit('connect')
      this.tokenuser = Decode.decodeToken(localStorage.getItem('tokenuser'))
      this.centrifugeConnect(this.$route.params.id)
      // this.getlistbot()
      this.check_admin_bot()
    } else {
      this.$router.push('/login')
    }
  },
  watch: {
    '$route.params.id' () {
      // console.log(this.$route.params.id)
      localStorage.removeItem('tokenbot')
      localStorage.removeItem('listchat')
      this.actionF = this.$route.params.id
      // this.getlistbot()
      this.check_admin_bot()
    },
    actionF () {
      this.$socket.emit('leave', { room: localStorage.getItem('tokenbot') })
      localStorage.setItem('tokenbot', this.$route.params.id)
      this.$socket.emit('connect')
      // disconnect centrifuge ตอนเปลี่ยนบอท
      centrifuge.on('disconnect', function (context) {
        console.log(context.reason)
      })
      centrifuge.disconnect()
      // connect centrifuge บอทตัวใหม่
      this.centrifugeConnect(this.$route.params.id)
      // this.getlistbot()
      this.check_admin_bot()
    },
    update_profilebot (data) {
      // console.log(data)
      this.updateprofilebot(data)
    }
  },
  sockets: {
    connect () {
      console.log('socket connected')
      // console.log(localStorage.getItem('tokenbot'))
      this.$socket.emit('join', { room: localStorage.getItem('tokenbot'), type: 'web' })
    },
    disconnect: function () {
      console.log('disconnect')
    },
    // message (data) {
    //   console.log('message')
    //   // console.log(data)
    //   // console.log(this.$route.params.id)
    //   if (data.hasOwnProperty('tokenuser')) {
    //     this.axios.post(process.env.VUE_APP_API_ALPINE + '/api/v3/getmessage', { tokenmessage: data.tokenmessage, tokenuser: this.$route.params.id }).then((response) => {
    //       if (response.data.status === 'success') {
    //         this.socketmessage = response.data.source
    //         // console.log(this.socketmessage)
    //         if (data.tokenuser !== this.$route.params.id && data.tokenroom !== this.$route.params.roomid) {
    //           if (response.data.source.typeofmessage !== 'message') {
    //             this.noti_msg(response.data.source.nickname, 'Send:  ' + response.data.source.typeofmessage + ' to you', response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type, this.$route.params.id)
    //           } else {
    //             this.noti_msg(response.data.source.nickname, 'Message:  ' + response.data.source.message, response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type, this.$route.params.id)
    //           }
    //         }
    //       }
    //     })
    //   }
    // },
    event_active_group (data) {
      console.log('event_active_group')
      // console.log(data)
      this.socketactive_group = data
      if (data.tokenuser !== this.$route.params.id) {
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/getgroup', { group_id: data.groupid, tokenuser: this.$route.params.id }).then((response) => {
          this.groupnameTest = response.data.group.name
          this.axios.post(process.env.VUE_APP_API_MANAGE + '/getuser', { owner: this.$route.params.id, tokenuser: [data.tokenuser] }).then((responsed) => {
            this.other_noti('Accept group', responsed.data['user'][0]['name'] + ' accept group ' + this.groupnameTest, responsed.data['user'][0]['profilepicture'])
          })
        })
      }
    },
    // event_invite_group (data) {
    //   console.log('event_invite_group')
    //   // console.log(data)
    //   this.socketinvite_group = data
    //   if (data.userinvited !== this.$route.params.id) {
    //     this.axios.post(process.env.VUE_APP_API_MANAGE + '/getuser', {owner: this.$route.params.id, tokenuser: [data.userinvited]}).then((responsed) => {
    //       this.other_noti(data.message, responsed.data['user'][0]['profilepicture'])
    //     })
    //   }
    // },
    event_kick_group (data) {
      console.log('event_kick_group')
      this.socket_kickmember = data
    },
    event_friend (data) {
      console.log('event_friend')
      // console.log(data)
    },
    event_accept_friend (data) {
      // console.log(data)
      console.log('event_accept_friend')
      if (data.tokenuser === this.$route.params.id) {
        this.socketaccept_friend = data
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/searchtokenuser', { tokenuser: data.tokenuser, tokenfriend: data.tokenfriend }).then((response) => {
          // console.log(response.data)
          if (response.data['user']['type'] !== 'business') {
            this.other_noti('Accept Friend', 'You and ' + response.data['user']['name'] + ' are friend.', response.data['user']['profilepicture'])
          }
        })
      }
    },
    event_remove_friend (data) {
      console.log('event_remove_friend')
      this.socketremove_friend = data
    },
    event_block (data) {
      console.log('event_block')
      if (data.hasOwnProperty('tokenuser')) {
        this.socketblock = data
      }
    },
    event_leave_group (data) {
      console.log('event_leave_group')
      this.socketleave_group = data
    },
    // message_read (data) {
    //   // console.log(data)
    //   console.log('markread')
    //   this.socketmarkread = data
    // },
    // event_unsend (data) {
    //   console.log('event_unsend')
    //   this.socket_unsendmessage = data
    // },
    // quick_reply (data) {
    //   console.log('quick_reply')
    //   this.socketquickreply = data
    // },
    // disable_quick_reply (data) {
    //   console.log('disable_quick_reply')
    //   this.socketdisablequickreply = data
    // },
    // disable_approve (data) {
    //   console.log('disable_approve')
    //   this.socketdisableapprove = data
    // },
    register_inetevent (data) {
      console.log('register_inetevent')
      // console.log(data)
      var dataevent = {}
      this.axios.post(process.env.VUE_APP_API_DEVELOP + '/getRegister', data).then((response) => {
        // console.log(response.data.data)
        dataevent = response.data.data
        if (data.event_id === this.$route.params.eventid) {
          this.socket_register_event = dataevent
        } else {
          this.other_noti('ตอบรับเข้าร่วมงาน', dataevent.name + ' ตอบรับเข้าร่วมงาน')
        }
      })
    },
    change_official_status (data) {
      console.log('change_official_status mobile')
      this.socket_official_status = data
      // console.log(this.socket_official_status)
    }
  },
  methods: {
    centrifugeConnect (tokenuser) {
      // console.log('wwwwwwwwwwww')
      var me = this
      var events = ''
      var dataMsg = ''
      centrifuge.setToken(process.env.VUE_APP_CENTRIFUGE_KEY)
      centrifuge.subscribe(tokenuser, function (message) {
        // console.log(message.data)
        events = message.data.event
        dataMsg = message.data.data
        console.log(`centrifuge: ${events}`)
        // console.log(dataMsg)
        if (events === 'message') {
          if (dataMsg.last_tokenmessage !== undefined) {
            // event unsend
            console.log('centrifuge: unsend msg')
            me.socket_unsendmessage = dataMsg
          } else {
            // console.log(dataMsg)
            // ถ้าข้อความเป็น type official_template, system เก็ทข้อความแบบเดิม ส่วน type อื่นรับปกติ
            if (dataMsg.typeofmessage === 'official_template' || dataMsg.typeofmessage === 'system' ||
             dataMsg.typeofmessage === 'system_action') {
              me.axios.post(process.env.VUE_APP_API_ALPINE + '/api/v3/getmessage', { tokenmessage: dataMsg.tokenmessage, tokenuser: me.token }).then((response) => {
                me.socketmessage = response.data.source
              })
            } else {
              // event message
              me.socketmessage = dataMsg
            }
            // console.log(me.socketmessage)
            if (dataMsg.option !== undefined) {
              me.typeAgoraCall = dataMsg.option
            }
          }
          if (me.socketmessage.tokenuser !== tokenuser) {
            if (me.$route.params.roomid !== undefined && me.$route.params.roomid !== me.socketmessage.tokenroom) {
              if (me.socketmessage.typeofmessage !== 'message') {
                me.noti_msg(me.socketmessage.nickname, 'Send:  ' + me.socketmessage.typeofmessage + ' to you', me.socketmessage.tokenroom, me.socketmessage.path_pic, me.socketmessage.type, tokenuser)
              } else {
                me.noti_msg(me.socketmessage.nickname, 'Message:  ' + me.socketmessage.message, me.socketmessage.tokenroom, me.socketmessage.path_pic, me.socketmessage.type, tokenuser)
              }
            }
          }
        } else if (events === 'disable_quick_reply') {
          me.socketdisablequickreply = dataMsg
        } else if (events === 'update-agora') {
          me.socket_update_agora = dataMsg
        } else if (events === 'accept_call') {
          me.socket_accept_call = dataMsg
          console.log(me.socket_accept_call)
        } else if (events === 'message_read') {
          console.log('message_read: centrifuge')
        } else if (events === 'quick_reply') {
          me.socketquickreply = dataMsg
        } else if (events === 'disable_approve') {
          me.socketdisableapprove = dataMsg
        }
      })
      centrifuge.on('connect', function () {
        console.log('connected centrifuge')
      })
      centrifuge.on('disconnect', function () {
        console.log('disconnected centrifuge')
      })
      centrifuge.connect()
    },
    check_admin_bot () {
      // console.log(localStorage.getItem('tokenbot'))
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/getbotowner', { bot_id: localStorage.getItem('tokenbot') }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data.bot_owner)
          this.progress = false
          var me = this
          if (_.find(response.data.bot_owner, function (o) { return o.tokenuser === me.tokenuser })) {
            this.getlistbot()
          } else {
            localStorage.clear()
            this.$router.push('/login')
          }
        } else {
          this.progress = false
        }
      })
    },
    other_noti (title, notimsg, pic) {
      if (pic === '') {
        pic = '../../assets/robot1.png'
      }
      if (Notification.permission === 'granted') {
        var notification = new Notification(title, { body: notimsg, icon: pic, silent: true })
        notification.onclick = function () {
        }
      } else {
        Notification.requestPermission().then(function (result) {
          console.log(result)
        })
      }
    },
    noti_msg (name, notimsg, room, pic, type, tokenbot) {
      if (pic === '') {
        pic = '../../assets/robot1.png'
      }
      if (Notification.permission === 'granted') {
        var notification = new Notification('New message from ' + name, { body: notimsg, icon: pic, silent: true })
        notification.onclick = function () {
          window.open('/chat-mobile/' + tokenbot + '/' + room, '_parent').focus()
        }
      } else {
        Notification.requestPermission().then(function (result) {
          console.log(result)
        })
      }
    },
    updateprofilebot (data) {
      // console.log(data)
      var indexlistbot = ''
      if (data.event === 'update_picture') {
        indexlistbot = _.findIndex(this.listbot, function (o) { return o.tokenuser === data.tokenuser })
        this.listbot[indexlistbot].profilepicture = data.picture
        this.profilepicture = data.picture
      } else if (data.event === 'update_name') {
        indexlistbot = _.findIndex(this.listbot, function (o) { return o.tokenuser === data.tokenuser })
        this.listbot[indexlistbot].nickname = data.name
        this.name = data.name
      } else if (data.event === 'update_status') {
        indexlistbot = _.findIndex(this.listbot, function (o) { return o.tokenuser === data.tokenuser })
        this.listbot[indexlistbot].status = data.status
      }
    },
    updatelistbot (botid) {
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/getbot', { tokenuser: this.tokenuser, bot_id: botid }).then((response) => {
        if (response.data.status === 'success') {
          if (_.find(this.listbot, function (o) { return o.bot_id === botid }) === undefined) {
            this.listbot.unshift({
              nickname: response.data.data_bot[0].nickname,
              bot_id: response.data.data_bot[0].bot_id,
              tokenuser: response.data.data_bot[0].tokenuser,
              profilepicture: response.data.data_bot[0].profilepicture,
              status: response.data.data_bot[0].status
            })
            this.profilepicture = response.data.data_bot[0].profilepicture
            this.name = response.data.data_bot[0].nickname
            this.botid = response.data.data_bot[0].bot_id
            this.listbot = _.orderBy(this.listbot, ['nickname'], ['asc'])
          }
        }
      })
    },
    createdaccount (data) {
      localStorage.removeItem('listchat')
      this.$router.push(data)
    },
    routeinfobot (data, index) {
      // console.log(data)
      // localStorage.removeItem('tabs')
      localStorage.setItem('tabs', 'tab-1')
      this.actionF = data.tokenuser
      this.profilepicture = data.profilepicture
      this.name = data.nickname
      this.botid = data.bot_id
      this.$router.push('/listchat/' + data.tokenuser)
    },
    getlistbot () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/web/getlistbot', { tokenuser: this.tokenuser }).then((response) => {
        // console.log(response.data)
        if (response.data.message === 'success') {
          this.progress = false
          this.listbot = response.data.listbot
          // console.log(window.location.pathname)
          if (this.listbot.length !== 0) {
            this.listbot = _.orderBy(this.listbot, ['nickname'], ['asc'])
            if (window.location.pathname === '/') {
              this.profilepicture = this.listbot[0].profilepicture
              this.name = this.listbot[0].nickname
              this.botid = this.listbot[0].bot_id
              this.$router.push('/listchat/' + this.listbot[0].tokenuser)
              this.actionF = this.listbot[0].tokenuser
            } else {
              var tokenbot = this.$route.params.id
              var indexlistbot = _.findIndex(this.listbot, function (o) { return o.tokenuser === tokenbot })
              this.profilepicture = this.listbot[indexlistbot].profilepicture
              this.name = this.listbot[indexlistbot].nickname
              this.botid = this.listbot[indexlistbot].bot_id
              // this.$router.push('/listchat/' + this.listbot[indexlistbot].tokenuser)
              this.actionF = this.listbot[indexlistbot].tokenuser
            }
          } else {
            this.actionF = ''
            this.profilepicture = ''
            this.name = ''
            this.botid = ''
            this.$router.push('/homepage')
          }
        }
        this.listbot = _.orderBy(this.listbot, ['nickname'], ['asc'])
        this.setTagOneSignal()
      })
    },
    setTagOneSignal () {
      for (var i = 0; i < this.listbot.length; i++) {
        // console.log(this.listbot[i].tokenuser)
        window.OneSignal.sendTag(this.listbot[i].tokenuser, '1')
      }
    },
    logout () {
      localStorage.clear()
      this.$router.push('/login')
      window.OneSignal.getTags(function (listTags) {
        var listKey = Object.keys(listTags)
        for (var i = 0; i < listKey.length; i++) {
          window.OneSignal.deleteTag(listKey[i])
        }
      })
    },
    getPlayerId (actionF) {
      window.OneSignal.getUserId(function (id) {
        console.log(id)
      })
      this.id_bot = actionF
      if (this.id_bot !== undefined) {
        this.$router.push(`/settings-mobile/profile/${this.id_bot}`)
      } else {
        this.$router.push('/createaccount-mobile')
      }
      // this.$router.push(`/listchat/settings-mobile/profile/${this.id_bot}`)
    }
  }
}
</script>
<style type="text/css" scoped>
.long_text0 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 105px;
}
.long_text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 105px;
}
.btn_avatar:hover {
  background-color: #607d8b1c !important;
  cursor: pointer !important;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
}
.btn_avatar:active {
  background-color: #cfd8dc !important;
  cursor: pointer !important;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
}
>>>.v-text-field > .v-input__control > .v-input__slot {
  width: auto;
  border: 1px solid #607d8b !important;
  border-radius: 50px !important;
  background: white !important;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.selectF {
  cursor: pointer !important;
  color: black !important;
  background-color: #607d8b4d !important;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
}
.nonselectF {
  cursor: pointer !important;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
}
.nonselectF:hover {
  background-color: #607d8b1c !important;
  cursor: pointer !important;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
}
.scrolling-wrapper {
  display: flex;
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.layoutprofile {
  height: 100px !important;
  margin-top: 30px !important;
  margin-bottom: 15px !important;
}
.fixedfooter {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
>>>.v-navigation-drawer .v-list {
  width: 100%;
  background: inherit;
}
>>>.v-list .v-list--dense .theme--light {
  padding-top: 0px;
  padding-bottom: 0px;
}
>>>.v-list--dense {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
